import moment from 'moment-jalaali';

export const columns = [
  { title: 'ردیف', key: '#id', style: { width: 60 } },
  { title: 'عنوان', key: 'title' },
  {
    title: 'ساعت کلاس',
    key: 'startTime',
    style: { width: 90 },
    render: ({ startTime, endTime }) =>
      !startTime && !endTime
        ? '-'
        : `${startTime / 3600000 ?? '-'} تا ${endTime / 3600000 ?? '-'}`
  },
  {
    title: 'روز و محل ارائه',
    key: 'presentationDay',
    style: { width: 220 },
    render: ({ methodPresentation, presentationDay, location }) => (
      <span>
        {methodPresentation} - {presentationDay}
        <hr />
        {location ?? '-'}
      </span>
    )
  },
  { title: 'استاد', key: 'professor', style: { width: 100 } },
  {
    title: 'تاریخ و زمان آزمون',
    key: 'examDate',
    style: { width: 90 },
    render: ({ examDate, startExamTime, endExamTime }) => (
      <span>
        {examDate ? moment(new Date(examDate)).format('jYYYY/jM/jD') : '-'}
        <hr />
        {!startExamTime && !endExamTime ? '-' : null}
        {startExamTime ? `${startExamTime / 3600000}` : ''}
        {startExamTime && endExamTime ? ' تا ' : ''}
        {endExamTime ? `${endExamTime / 3600000}` : ''}
      </span>
    )
  }
];

export default columns;
